import { Tabs } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { FilterContext } from 'Components/Filter/context'
import React, { useContext } from 'react'
import { CONTENT_TYPES } from 'Scenes/constants'
import Chip from 'Theme/Chip'
import CustomMuiTab from 'Theme/Tab'

const useStyles = makeStyles((theme) => ({
  tab: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    height: '55px',
    marginBottom: theme.spacing(0.5),
  },
  icon: {
    color: theme.palette.text.tertiary,
  },
  activeIcon: {
    color: theme.palette.text.primary,
  },
  chip: {
    ...theme.typography.overline,
    color: theme.palette.text.primary,
  },
}))

const SearchTabs = ({ contentType, setContentType, mapsTotal, prefabsTotal }) => {
  const classes = useStyles()
  const { clearFilters } = useContext(FilterContext)

  const handleChange = (_, value) => {
    setContentType(value)
    clearFilters()
  }

  return (
    <Tabs
      indicatorColor="secondary"
      value={contentType || CONTENT_TYPES.MAPS}
      onChange={handleChange}
      sx={(theme) => ({
        '& .MuiTab-root .MuiButtonBase-root': {
          ...theme.typography.h6,
        },
        '& .Mui-selected': {
          ...theme.typography.h5,
          color: `${theme.palette.text.primary}!important`,
        },
      })}
    >
      <CustomMuiTab
        key={CONTENT_TYPES.MAPS}
        value={CONTENT_TYPES.MAPS}
        label={
          <div className={classes.tab}>
            Maps
            {mapsTotal !== undefined && (
              <Chip
                size="small"
                label={mapsTotal || 0}
                className={classes.chip}
              />
            )}
          </div>
        }
      />
      <CustomMuiTab
        key={CONTENT_TYPES.PREFABS}
        value={CONTENT_TYPES.PREFABS}
        label={
          <div className={classes.tab}>
            Prefabs
            {prefabsTotal !== undefined && (
              <Chip
                size="small"
                label={prefabsTotal || 0}
                className={classes.chip}
              />
            )}
          </div>
        }
      />
    </Tabs>
  )
}

export default SearchTabs
